import axios from 'axios';

// Réutilise axios global (main.js : withCredentials, CSRF, refresh cookie)
export const http = axios;

export function normalizeListPayload(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}
